import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Button from '../../components/form-control/Button';
import { copyTextToClipboard } from '../../utilities/miscFunctions';

interface PaymentModalProps {
    onProceed?: () => void;
    onClose?: () => void;
    link: string;
}


const PaymentLinkModal = ({ onProceed, onClose, link }: PaymentModalProps) => {
    const [copied, setCopied] = useState<boolean>(false)

    const handleCopyClick = (value: string) => {
        copyTextToClipboard(value)
            .then(() => {
                setCopied(!copied)
                toast.success('Copied to clipboard', {
                    autoClose: 3000
                });
            })
            .catch((err: any) => { }).finally(() => {
                setTimeout(() => {
                    setCopied(false)
                }, 2000)
            })
    };

    return (
        <div className="p-5 ">
            <div className="text-sm mb-5 cursor-pointer p-2 bg-slate-300 rounded">{link}</div>

            <div className="flex items-center justify-end w-full">
                <Button label={copied ? "copied" : "copy"} onClick={() => handleCopyClick(link)} className='bg-primary-main px-3 !py-1' />
            </div>
        </div>
    );
};

export default PaymentLinkModal;
